export const TABS = {
    alle: {
        tag: 'alle',
        title: 'Alle',
    },
    gameTips: {
        tag: 'tips',
        title: 'Spiltips',
    },
    /*new: {
        tag: 'news',
        title: 'Nyheder',
    },*/
};
